import { render, staticRenderFns } from "./AdminPolicyList.vue?vue&type=template&id=4112d699&"
import script from "./AdminPolicyList.vue?vue&type=script&lang=js&"
export * from "./AdminPolicyList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports